import {CashPaymentResponse} from '../../../pages/shopping-basket/cash-payment/utils/types';
import request from '../../axios';

export const getStoreOrderCashTransactionPrice = async (storeGuid?: string) => {
  const {data}: {data: CashPaymentResponse} = await request.get(
    `/api/v2/payment/store-order-cash-transaction-price`,
    {
      params: {store_order: storeGuid},
    },
  );

  return data;
};
